import * as React from "react";
import { Flex, Text, VStack, Wrapper, Pagination, Search } from "components";
import { useOnline } from "duck";
import * as LC from "./components";
import { hooks, SelectionContext, utils } from "./duck";

const List: React.FC = () => {
  const online = useOnline();

  const { ready } = hooks.useInitFilters();

  const { offlineCases, needSyncCases, cachedCases } = hooks.useOfflineCases();

  const { pageNumber, loading, cases, totalCount } = hooks.useOnlineCases({
    skip: !ready
  });

  const {
    selection,
    reset,
    onCaseClick,
    containerProps
  } = hooks.useSelection();

  return (
    <SelectionContext.Provider value={{ selection, reset }}>
      <Flex flex="1" flexDirection="column" gridGap="24px" {...containerProps}>
        <LC.Title />

        <Wrapper>
          <VStack width="100%" spacing="32px">
            <Search />
            <LC.Filters />
          </VStack>

          <Flex flexDirection="row" flexWrap="wrap" gap={8} mt="34">
            {ready ? (
              <>
                {pageNumber === 1 &&
                  offlineCases.map(medCase => (
                    <LC.Case
                      {...utils.getProps(medCase, selection)}
                      avatar={medCase.client.patient.image}
                      onClick={event =>
                        onCaseClick(
                          { ...medCase, offlineStatus: "offline" },
                          event
                        )
                      }
                      pending
                    />
                  ))}

                {pageNumber === 1 &&
                  needSyncCases.map(medCase => (
                    <LC.Case
                      {...utils.getProps(medCase, selection)}
                      avatar={medCase.client.patient.image}
                      onClick={event =>
                        onCaseClick(
                          { ...medCase, offlineStatus: "has_offline_changes" },
                          event
                        )
                      }
                      needSync
                    />
                  ))}

                {!online &&
                  cachedCases.map(medCase => (
                    <LC.Case
                      {...utils.getProps(medCase, selection)}
                      avatar={medCase.client.patient.image}
                      onClick={event =>
                        onCaseClick(
                          { ...medCase, offlineStatus: "offline" },
                          event
                        )
                      }
                    />
                  ))}

                {online && !cases ? (
                  <LC.Skeleton />
                ) : (
                  (cases || []).map(medicalCase => (
                    <LC.Case
                      {...utils.getProps(medicalCase, selection)}
                      avatar={medicalCase.client.patient.image?._id || null}
                      onClick={event =>
                        onCaseClick(
                          { ...medicalCase, offlineStatus: "normal" },
                          event
                        )
                      }
                    />
                  ))
                )}

                {!loading &&
                  needSyncCases.length === 0 &&
                  (online ? true : cachedCases.length === 0) &&
                  !offlineCases.length &&
                  (cases ? cases.length === 0 : true) && (
                    <Flex justifyContent="center" w="100%">
                      <Text fontWeight={600} fontSize="16px" align="center">
                        No results found
                      </Text>
                    </Flex>
                  )}
              </>
            ) : (
              <LC.Skeleton />
            )}
          </Flex>

          {!loading && (
            <Pagination perPage={100} p={0} mt={6} total={totalCount} />
          )}
        </Wrapper>
      </Flex>
    </SelectionContext.Provider>
  );
};

export default List;
